module.exports = __webpack_public_path__ + "img/best-business-broker.f2d0c02b.jpg";